'use strict';

angular.module('esn.calendar')
  .component('calImportCalendarMenuItem', {
    template: require('./import-calendar-menu-item.pug')
  });
